import { render } from "./AuthenticationForm.vue?vue&type=template&id=e95e63b8&scoped=true"
import script from "./AuthenticationForm.vue?vue&type=script&lang=js"
export * from "./AuthenticationForm.vue?vue&type=script&lang=js"

import "./AuthenticationForm.vue?vue&type=style&index=0&id=e95e63b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95e63b8"]])

export default __exports__